import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";
import { useAuth } from "react-oidc-context";

import type { Role } from "shell/platform/types/types";

import {
  PMCODES_CLAIM_KEY,
  ROLES_CLAIM_KEY,
} from "shell/platform/constants/constants";

interface IdToken {
  acr: string;
  aid: string;
  amr: any[];
  at_hash: string;
  aud: string;
  auth_time: number;
  email: string;
  exp: number;
  family_name: string;
  given_name: string;
  iat: number;
  idp: string;
  idpm: string;
  iss: string;
  jti: string;
  sid: string;
  sub: string;
  tid: string;
  [ROLES_CLAIM_KEY]: undefined | Array<Role>;
  [PMCODES_CLAIM_KEY]: string[];
}

interface AccessToken {
  acr: string;
  aid: string;
  amr: any[];
  aud: string[];
  companyid: string;
  exp: number;
  iat: number;
  idp: string;
  iss: string;
  jti: string;
  multipmid?: Array<{
    pmcode: string;
    pmid: number;
  }>;
  nbf: number;
  pmid?: number;
  regions?: Array<{ region: string }>;
  scp: string[];
  st: string;
  sub: string;
  tid: string;
}

export const useDecodedTokens = () => {
  const auth = useAuth();
  const idToken = auth?.user?.id_token;
  const accessToken = auth?.user?.access_token;
  return useMemo(
    () => ({
      idToken: idToken ? jwtDecode<IdToken>(idToken) : undefined,
      accessToken: accessToken
        ? jwtDecode<AccessToken>(accessToken)
        : undefined,
    }),
    [idToken, accessToken],
  );
};
